import styled from "styled-components";

const ButtonGroup = styled.div`
  display: inline-block;
  border: 1px solid #007aff;
  border-radius: 2px;
  margin-left: ${props => (props.open ? "-4px" : "-100%")};
  transition: 500ms;
  line-height: 20px;
  padding-left: 2px;
  height: 20px;
  box-sizing: border-box;

  > div {
    display: inline-block;
    cursor: pointer;
    padding: 0 8px;
    border-left: 1px solid #007aff;
    color: #007aff;
    font-weight: 600;
    font-family: sans-serif;
    font-size: 12px;

    &:hover {
      color: #fff;
      background: #007aff;
    }
  }
`;

export default ButtonGroup;
